import React from "react";
import Navbar from "../Components/Navbar/Navbar";
import ProductCard from "../Components/ProductCard/ProductCard";
import Footer from "../Components/Footer/Footer";
import { Box } from "@mui/material";
import CardImg from "../Assets/vegan_magenta_leaf_1200x900.png";
import { Helmet } from "react-helmet-async";
import useMetaTracking from "../hooks/useMetaTracking";

function MagentaLeavesXoi() {
  useMetaTracking("ViewContent", {
    content_name: "Sweet Xoi - Magenta Leaves",
    content_category: "Vegan Menu",
    content_ids: ["sweet_xoi_magenta_leaves"],
    content_type: "vegan_xoi",
    value: 5.0,
    currency: "USD",
  });

  return (
    <>
      <Helmet>
        <title>Magenta Leaves Sticky Rice (Xôi Lá Cẩm) | Đông Hưng Viên Bakery</title>
        <meta
          name="description"
          content="This stunning purple xôi is a classic. The color comes from magenta leaves (lá cẩm), not dye. Mild, clean sweetness with perfectly chewy texture."
        />
        <meta
          property="og:title"
          content="Magenta Leaves Sticky Rice (Xôi Lá Cẩm) | Đông Hưng Viên Bakery"
        />
        <meta
          property="og:description"
          content="Naturally purple from lá cẩm—mildly sweet with a perfect chewy bite."
        />
        <meta property="og:image" content={CardImg} />
      </Helmet>

      <Box className="product-page" sx={{ pt: 10, background: "#0f0f0f" }}>
        <Navbar />
        <ProductCard
          cardImg={CardImg}
          titleHead="Magenta Leaves Sticky Rice"
          titleSubHead="Xôi Lá Cẩm · $5.00 each"
          detailBody="This stunning purple xôi is a classic. The color comes from a special leaf (lá cẩm), not dye. It's a simple, delicious treat where the real star is the perfectly chewy texture and gentle sweetness of the sticky rice."
          detailBodyBr={
            <>
              Contains: coconut
              <br />
              <br />
              <em>Vegan, Gluten-Free</em>
            </>
          }
          ProductCardBtn="View Full Vegan Menu"
          btnLink="/vegan-menu"
        />
        <Footer />
      </Box>
    </>
  );
}

export default MagentaLeavesXoi;